import { render, staticRenderFns } from "./ShortContent.vue?vue&type=template&id=486a30c4&scoped=true"
import script from "./ShortContent.vue?vue&type=script&lang=js"
export * from "./ShortContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a30c4",
  null
  
)

export default component.exports